<template>
  <div class="navigation" v-show="!isPageLoading">
    <ul>
      <li>
        <router-link :to="{ name: 'UserLogin' }" class="nav-link">Login</router-link>
      </li>
      <li>
        <router-link :to="{ name: 'UserPasswordForgot' }" class="nav-link">Glemt Passord?</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MainNavigation',
  computed: {
    ...mapGetters(['isPageLoading'])
  }
}
</script>

<style scoped>
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Guest/TheMainNavigation.vue